// extracted by mini-css-extract-plugin
export default {"button":"PdfButton_button__eZrEO","button_blue":"PdfButton_button_blue__PVEk6"};